/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { TopByRevenueRequestBuilderRequestsMetadata, type TopByRevenueRequestBuilder } from './topByRevenue/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/analytics/categories
 */
export interface CategoriesRequestBuilder extends BaseRequestBuilder<CategoriesRequestBuilder> {
    /**
     * The topByRevenue property
     */
    get topByRevenue(): TopByRevenueRequestBuilder;
}
/**
 * Uri template for the request builder.
 */
export const CategoriesRequestBuilderUriTemplate = "{+baseurl}/api/analytics/categories";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const CategoriesRequestBuilderNavigationMetadata: Record<Exclude<keyof CategoriesRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    topByRevenue: {
        requestsMetadata: TopByRevenueRequestBuilderRequestsMetadata,
    },
};
/* tslint:enable */
/* eslint-enable */
